import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { TrlTooltip } from '../TrlTooltip';
import { InfoIcon } from './TrlInfoIcon.styles';

export const TrlInfoIcon = ({ infoText }) => (
  <TrlTooltip text={infoText}>
    <InfoIcon icon={faCircleInfo} />
  </TrlTooltip>
);

TrlInfoIcon.propTypes = {
  infoText: PropTypes.string.isRequired,
};
